import { useMutation } from 'react-query';

import { CreateVerifyEmail } from '~/../api/common.types';
import { api } from '~/client/api';

export const useSubmitEmailVerified = () => {
  return useMutation((data: CreateVerifyEmail) => {
    return api.createVerifyEmail(data);
  });
};
